import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  CincinnatiBell,
  Comcast,
  Cox,
  Earthlink,
  Spectrum,
  WOW,
  TDS,
  Mediacom,
  Frontier,
  Windstream,
  Verizon,
} from 'config/providers';
import { SpectrumTheme } from 'config/themes';

// Origin - https://updater.atlassian.net/browse/TVI-1040
export const AdActionSpectrumPartner: SingleProviderConfig = {
  name: 'AdActionSpectrumPartner',
  micrositeCode: 'adactionspectrumpartner',
  mainProvider: Spectrum,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'spectrumspecial.com',
  homepage: 'https://spectrumspecial.com',
  title: 'Spectrum Authorized Dealer',
  fallbackPhoneNumber: '855-630-1841',
  fallbackLeadModePhoneNumber: '855-438-7281',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: SpectrumTheme,
  needsDcSession: false,
  source: 'Spectrum',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [Cox, Comcast, Mediacom, WOW],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    CincinnatiBell,
    Earthlink,
    Frontier,
    TDS,
    Windstream,
    Verizon,
  ],
};
